"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components"); // eslint-disable-next-line react/prop-types,react/display-name


exports.wrapRootElement = function (_ref, pluginOptions) {
  var element = _ref.element;
  return /*#__PURE__*/_react.default.createElement(_styledComponents.StyleSheetManager, {
    disableVendorPrefixes: (pluginOptions === null || pluginOptions === void 0 ? void 0 : pluginOptions.disableVendorPrefixes) === true
  }, element);
};